import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import { FaPlus } from "react-icons/fa6";
import CommonCheckboxSimNao from "../../../components/forms/CommonCheckboxSimNao";

function UsuariosMigracaoModal({
  modalHook,
  usuarios,
  togUsuariosModal,
  togAdministradoresModal,
  isAdmin,
  atualizarStatusUsuario,
}) {
  const { usuariosMigracaoModal, setUsuariosMigracaoModal } = modalHook;

  const colunas = React.useMemo(
    () => [
      {
        Header: "Usuário",
        accessor: (row) => {
          return row?.nome;
        },
      },
      {
        Header: "E-mail",
        accessor: (row) => {
          return row?.email;
        },
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          const uid = row.original.uid;
          return (
            <>
              <CommonCheckboxSimNao
                label={null}
                id={`ativo-${uid}`}
                value={row.original.ativo === 1}
                onChange={() => {
                  atualizarStatusUsuario(
                    uid,
                    row.original.ativo === 1
                  );
                }}
                dataOnLabel="Ativo"
                dataOffLabel="Inativo"
              />
            </>
          );
        },
      },
    ],
    [atualizarStatusUsuario]
  );

  return (
    <CommonModal
      title="Usuários vinculados"
      is_open_modal={usuariosMigracaoModal}
      set_is_open_modal={setUsuariosMigracaoModal}
      size="lg"
      buttons={<></>}
    >
      <div className="row">
        <div className="col-lg-12 px-3">
          <CommonDataTable
            colunas={colunas}
            linhas={usuarios}
            botoes={
              <ButtonRounded
                onClick={isAdmin ? togAdministradoresModal : togUsuariosModal}
                color="success"
                icon={<FaPlus />}
              >
                Vincular usuário
              </ButtonRounded>
            }
          />
        </div>
      </div>
    </CommonModal>
  );
}

UsuariosMigracaoModal.propTypes = {
  modalHook: PropTypes.shape({
    usuariosMigracaoModal: PropTypes.bool.isRequired,
    setUsuariosMigracaoModal: PropTypes.func.isRequired,
  }).isRequired,
  usuarios: PropTypes.object.isRequired,
  togUsuariosModal: PropTypes.func.isRequired,
  togAdministradoresModal: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  atualizarStatusUsuario: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default UsuariosMigracaoModal;
